import { render, staticRenderFns } from "./SendQuoteConfirmation.vue?vue&type=template&id=2ae2e4bc&scoped=true&"
import script from "./SendQuoteConfirmation.vue?vue&type=script&lang=js&"
export * from "./SendQuoteConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SendQuoteConfirmation.vue?vue&type=style&index=0&id=2ae2e4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2e4bc",
  null
  
)

export default component.exports